
import { v4 as uuid } from 'uuid';

export class QuickSaleCharge {
    allowAttachments = false;
    isBillable = false;
    isSurcharge = false;
    billingDetailId = uuid();
    timesheetDetailId = null;
    chargeTypeId = null;
    customDescription = '';
    description = '';
    qty = 0;
    equipmentDescription = '';
    equipmentId = null;
    units = '';
    unitsId = null;
    attachments = [];
}
export class QuickSale {
    id = null;
    saleDateTime = null;
    companyId = null;
    contractId = null;
    projectId = null;
    companyName = '';
    contractNumber = '';
    contractDescription = '';
    subcontractorId = null;
    dispatchOfficeId = null;
    requestedById = null;
    subcontractorContactId = null;
    workOrderNumber = '';
    purchaseOrderNumber = '';
    workRequest = '';
    invoiceId = null;
    locationId = null;
    location = null;
    isReadOnly = false;
    charges = [new QuickSaleCharge()];
    project = null;
    dispatchOffice = null;
    sessionId = null;
    notes = null;
}

export const quickSaleStatusOptions = [
    { label: 'New', value: 6 },
    { label: 'Approved', value: 4 },
    { label: 'Pending Review', value: 9 },
    { label: 'Rejected', value: 10 },
];